import i18n from 'i18next'

export default function getEnumLabel(key) {
    return i18n.t(key, {
        ns: 'enums',
    }) || key
}
